// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Profile Image Styles - Essential styles not covered by common components */
.profile-image-container {
  width: 120px;
  height: 120px;
  margin: 0 auto 1rem;
  position: relative;
}

.profile-image-large {
  width: 120px;
  height: 120px;
  object-fit: cover;
  border-radius: 8px;
  border: 2px solid #e9ecef;
  transition: transform 0.2s ease;
}

.profile-image-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  cursor: pointer;
  color: white;
}

.profile-image-container:hover .profile-image-overlay {
  opacity: 1;
}

.camera-icon-large {
  font-size: 24px;
  color: white;
}

/* Responsive Design */
@media (max-width: 768px) {
  .profile-image-container {
    width: 100px;
    height: 100px;
  }
  
  .profile-image-large {
    width: 100px;
    height: 100px;
  }
  
  .camera-icon-large {
    font-size: 20px;
  }
}

@media (max-width: 576px) {
  .profile-image-container {
    width: 80px;
    height: 80px;
  }
  
  .profile-image-large {
    width: 80px;
    height: 80px;
  }
  
  .camera-icon-large {
    font-size: 18px;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/Site/Partner/PartnerProfile.css"],"names":[],"mappings":"AAAA,6EAA6E;AAC7E;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;EAC7B,eAAe;EACf,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Profile Image Styles - Essential styles not covered by common components */\n.profile-image-container {\n  width: 120px;\n  height: 120px;\n  margin: 0 auto 1rem;\n  position: relative;\n}\n\n.profile-image-large {\n  width: 120px;\n  height: 120px;\n  object-fit: cover;\n  border-radius: 8px;\n  border: 2px solid #e9ecef;\n  transition: transform 0.2s ease;\n}\n\n.profile-image-overlay {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.3s ease;\n  cursor: pointer;\n  color: white;\n}\n\n.profile-image-container:hover .profile-image-overlay {\n  opacity: 1;\n}\n\n.camera-icon-large {\n  font-size: 24px;\n  color: white;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .profile-image-container {\n    width: 100px;\n    height: 100px;\n  }\n  \n  .profile-image-large {\n    width: 100px;\n    height: 100px;\n  }\n  \n  .camera-icon-large {\n    font-size: 20px;\n  }\n}\n\n@media (max-width: 576px) {\n  .profile-image-container {\n    width: 80px;\n    height: 80px;\n  }\n  \n  .profile-image-large {\n    width: 80px;\n    height: 80px;\n  }\n  \n  .camera-icon-large {\n    font-size: 18px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
